import axios from "axios";
import apiService from "@/services/api.service";
const API = process.env.REACT_APP_API_URL;

export const uploadInventoryExcel = async (formData) => {
	return await apiService.post("/client/implementation/upload_excel", formData);
};

export const uploadBusinessBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_business", formData);
};

export const uploadParentEstateBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_estates_parents", formData);
};

export const uploadEstateBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_estates", formData);
};

export const uploadUsersBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_users", formData);
};

export const uploadBusinessCenterParentBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_business_centers_parent", formData);
};

export const uploadBusinessCenterBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_business_centers", formData);
};

export const uploadBalancesBulkLoader = async (formData) => {
	return await apiService.post("/client/implementation/save_balances", formData);
};

export const getInitialDataImplementation = async (params) => {
	const { data } = await axios.get(`${API}/client/implementation/initial_data`, {
		params,
	});
	return data;
};
